import Login from "./login.jpeg"

const Images = {
  Login,
}

export default Images
